// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3lm02","Logo":"Toolbar_Logo__2m-sk","DesktopOnly":"Toolbar_DesktopOnly__3HBqa"};